import styled from 'styled-components'

import LinkCSS from '../Links/A.css';
import { ButtonLink } from '../Inputs/Button.span';

const ValuePropPage = styled.div`
  position: relative;
  width: 100%;
  max-width: 960px;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  ul, ol {
    list-style-type: disc;
    li {
      margin-left: 0.5em;
    }
  }
  @media screen and (max-width: 45em) {
    flex-direction: column;
  }
  a:not(${ButtonLink}) { ${LinkCSS} }
  div {
    display: flex;
  }
  div:first-of-type {
    flex: 3;
    justify-content: center;
    align-items: center;
    margin: 0 1em;
    @media (max-width: 45em) {
      & > div {
        min-width: 100%;
        max-width: 480px;
      }
    }
    @media screen and (max-width: 45em) {
      margin: 0 2em;
      width: 100%;
    }
  }
  div:last-of-type {
    flex: 3;
    flex-direction: column;
    margin: 0;
    a, small {
      margin-top: .5em;
    }
  }
  div.value-prop__content {
    @media(max-width: 45em) {
      padding: 0 1em;
    }
  }
`;

export default ValuePropPage;
